import { Container } from "@mui/material"
import { useTranslation } from "react-i18next"

import Page from "@/components/Page"
import ItemsSection from "@/section/items"

import ItemsProvider from "./context"

export default function ItemsPage(): JSX.Element {
  const { t } = useTranslation("items")
  return (
    <Page title={t("Artikelen")}>
      <Container
        maxWidth="xl"
        sx={{
          pt: "0rem",
          pb: "4rem",
        }}
      >
        <ItemsProvider>
          <ItemsSection />
        </ItemsProvider>
      </Container>
    </Page>
  )
}
